import React from "react";
import "./HousekeepingServices.css";

// 👉 Replace with your own small icon
import ServiceIcon from "../../Image/HouseKeeping/rightthick.png";

const services = [
 "Electrical system maintenance",
  "HVAC & AHU servicing",
  "Plumbing & drainage management",
  "DG set operations & maintenance",
  "UPS & power backup management",
  "Lighting & fixture repairs",
  "Water pump maintenance",
  "Fire safety system checks",
  "Minor civil repairs",
  "Lift & elevator basic maintenance",
  "Building automation support",
  "Energy management assistance"
];

const steps = [
  {
    number: "01",
    title: "System Assessment",
    desc: "Comprehensive evaluation of your building systems and maintenance requirements.",
  },
  {
    number: "02",
    title: "Maintenance Planning",
    desc: "Create preventive maintenance schedules and deploy certified technicians.",
  },
  {
    number: "03",
    title: "Regular Servicing",
    desc: "Execute scheduled maintenance, safety checks, and system optimization.",
  },
  {
    number: "04",
    title: "Performance Monitoring",
    desc: "Track system performance, maintain logbooks, and provide detailed reports",
  },
];

const EngineeringTechnicalServices = () => {
  return (
    <>
      {/* ---------------- SERVICES SECTION ---------------- */}
      <section className="hk-services-section">
        <h2 className="hk-section-title">Our Service Includes</h2>

        <div className="hk-services-grid">
          {services.map((item, index) => (
            <div key={index} className="hk-service-card">
              <img src={ServiceIcon} alt="service" className="hk-service-img" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- PROCESS SECTION ---------------- */}
      <section className="hk-process-section">
        <div className="hk-process-tag">Our Process</div>
        <h2 className="hk-section-title">Our Maintenance Process</h2>

        <div className="hk-process-grid">
          {steps.map((step, index) => (
            <div key={index} className="hk-process-card">
              <div className="hk-process-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default EngineeringTechnicalServices;
